import { composeIO } from 'react-compose-io'
import { cardExpansivelIO } from './CardExpansivel.IO'
import { CardExpansivelView } from './CardExpansivel.View'

export const CardExpansivel = composeIO(CardExpansivelView, cardExpansivelIO)
